import { requirePlainObject } from "src/utils/strictData";

export function requireSignedIssuanceByYear(project, label) {
  return requirePlainObject(project?.signed_issuance_by_year, label);
}

export function readSignedIssuanceYears(project, label) {
  return Object.keys(requireSignedIssuanceByYear(project, label)).sort(
    (left, right) => Number(left) - Number(right)
  );
}

export function hasSignedIssuance(project, label) {
  return readSignedIssuanceYears(project, label).length > 0;
}

export function readLatestIssuance(project, label) {
  const latestIssuance = project?.latest_issuance;
  if (latestIssuance == null) {
    return null;
  }
  return requirePlainObject(latestIssuance, label);
}

export function readLatestIssuanceYear(project, label) {
  const latestIssuance = readLatestIssuance(project, label);
  if (latestIssuance == null) {
    return null;
  }
  const numericYear = Number(latestIssuance.year);
  if (!Number.isFinite(numericYear)) {
    throw new Error(`${label} year must be numeric`);
  }
  return numericYear;
}
